<template>
  <div class="">
    <div class="">
      <h1 class="text-2xl font-semibold text-slate-900 dark:text-white">
        لوحة التحكم
      </h1>
    </div>

    <div class="py-2 align-middle inline-block min-w-full mt-6">
      <div class="grid gap-y-10 gap-x-6 md:grid-cols-2 xl:grid-cols-3">
        <div
          class="relative flex flex-col bg-clip-border rounded-xl bg-white dark:bg-slate-700 dark:text-gray-200 text-gray-700 shadow-md"
        >
          <div class="p-4 text-right">
            <p
              class="block antialiased text-base leading-normal font-normal text-blue-gray-600"
            >
              المراكز الصحية
            </p>
            <h4
              class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900 dark:text-white"
            >
              {{ dashboard_data.total_of_health_center }}
            </h4>
          </div>

          <div
            class="bg-clip-border mx-4 rounded-xl overflow-hidden bg-gradient-to-tr from-blue-600 to-blue-400 text-white shadow-blue-500/40 shadow-lg absolute left-0 -mt-4 grid h-16 w-16 place-items-center"
          >
            <svg
              class="w-6 h-6 text-white stroke-current stroke-2"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              fill="none"
              viewBox="0 0 48 48"
            >
              <mask
                id="a"
                fill="#fff"
              >
                <path d="M23 12L5 12L5 14L23 14V12Z" />
                <path
                  fill-rule="evenodd"
                  d="M23 16H6V37H5C4.44772 37 4 37.4477 4 38C4 38.5523 4.44772 39 5 39H43C43.5523 39 44 38.5523 44 38C44 37.4477 43.5523 37 43 37H42V16H39V18H40V37H37V25H29V37H8V18H23V16ZM35 37H31V27H35V37Z"
                  clip-rule="evenodd"
                />
                <path d="M39 14V12L43 12V14L39 14Z" />
                <path
                  fill-rule="evenodd"
                  d="M11 32V25H26V32L27 32V34L10 34V32H11ZM13 27H24V32H13V27Z"
                  clip-rule="evenodd"
                />
                <path
                  d="M35 10H27C25.8954 10 25 10.8954 25 12V20C25 21.1046 25.8954 22 27 22H35C36.1046 22 37 21.1046 37 20V12C37 10.8954 36.1046 10 35 10Z"
                />
              </mask>
              <path
                fill="#333"
                d="M32 14V13H30V14H32ZM29 15H28V17H29V15ZM6 13V18H8V13H6ZM40 13V18H42V13H40ZM30 14V18H32V14H30ZM29 17L33 17V15L29 15V17ZM23 12H25V10L23 10V12ZM5 12L5 10L3 10L3 12L5 12ZM5 14L3 14L3 16H5L5 14ZM23 14V16H25V14H23ZM23 16H25V14H23V16ZM6 16V14H4V16H6ZM6 37V39H8V37H6ZM42 37H40V39H42V37ZM42 16H44V14H42V16ZM39 16V14H37V16H39ZM39 18H37V20H39V18ZM40 18H42V16H40V18ZM40 37V39H42V37H40ZM37 37H35V39H37V37ZM37 25H39V23H37V25ZM29 25V23H27V25H29ZM29 37V39H31V37H29ZM8 37H6V39H8V37ZM8 18V16H6V18H8ZM23 18V20H25V18H23ZM39 12V10L37 10V12H39ZM39 14H37V16H39V14ZM43 12H45V10L43 10V12ZM43 14V16L45 16V14H43ZM31 37H29V39H31V37ZM35 37V39H37V37H35ZM31 27V25H29V27H31ZM35 27H37V25H35V27ZM24 27H26V25H24V27ZM13 27V25H11V27H13ZM24 32V34H26V32H24ZM13 32H11V34H13V32ZM11 32V34H13V32H11ZM11 25V23H9V25H11ZM26 25H28V23H26V25ZM26 32H24V34L26 34L26 32ZM27 32H29V30L27 30L27 32ZM27 34V36H29V34H27ZM10 34H8V36H10V34ZM10 32V30H8V32H10ZM23 10L5 10L5 14L23 14V10ZM3 12L3 14L7 14V12L3 12ZM5 16L23 16V12L5 12L5 16ZM25 14V12H21V14H25ZM5 39H6V35H5V39ZM6 38C6 38.5523 5.55229 39 5 39V35C3.34315 35 2 36.3431 2 38H6ZM5 37C5.55229 37 6 37.4477 6 38H2C2 39.6569 3.34315 41 5 41V37ZM42 38C42 37.4477 42.4477 37 43 37V41C44.6569 41 46 39.6569 46 38H42ZM43 39C42.4477 39 42 38.5523 42 38H46C46 36.3431 44.6569 35 43 35V39ZM42 39H43V35H42V39ZM37 16V18H41V16H37ZM39 20H40V16H39V20ZM38 18V37H42V18H38ZM40 35H37V39H40V35ZM29 35H8V39H29V35ZM10 37V18H6V37H10ZM8 20H23V16H8V20ZM25 18V16H21V18H25ZM37 12V14H41V12H37ZM43 10L39 10V14L43 14V10ZM45 14V12H41V14H45ZM39 16L43 16V12L39 12V16ZM31 39H35V35H31V39ZM29 27V37H33V27H29ZM35 25H31V29H35V25ZM37 37V27H33V37H37ZM24 25H13V29H24V25ZM26 32V27H22V32H26ZM13 34H24V30H13V34ZM11 27V32H15V27H11ZM27 30L26 30L26 34L27 34L27 30ZM29 34V32H25V34H29ZM8 32V34H12V32H8ZM11 30H10V34H11V30ZM27 12H35V8H27V12ZM35 12V20H39V12H35ZM35 20H27V24H35V20ZM27 20V12H23V20H27ZM27 20H23C23 22.2091 24.7909 24 27 24V20ZM35 20V24C37.2091 24 39 22.2091 39 20H35ZM35 12H39C39 9.79086 37.2091 8 35 8V12ZM27 8C24.7909 8 23 9.79086 23 12H27V12V8ZM6 18H23V14H6V18ZM8 37V16H4V37H8ZM43 37H5V41H43V37ZM40 16V37H44V16H40ZM39 18H42V14H39V18ZM39 37V25H35V37H39ZM37 23H29V27H37V23ZM27 25V37H31V25H27ZM9 25V32H13V25H9ZM26 23H11V27H26V23ZM28 32V25H24V32H28ZM10 36L27 36V32L10 32V36Z"
                mask="url(#a)"
              />
            </svg>
          </div>
        </div>

        <div
          class="relative flex flex-col bg-clip-border rounded-xl bg-white dark:bg-slate-700 dark:text-gray-200 text-gray-700 shadow-md"
        >
          <div class="p-4 text-right">
            <p
              class="block antialiased text-base leading-normal font-normal text-blue-gray-600"
            >
              البلديات
            </p>
            <h4
              class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900 dark:text-white"
            >
              {{ dashboard_data.total_of_muncipal }}
            </h4>
          </div>

          <div
            class="bg-clip-border mx-4 rounded-xl overflow-hidden bg-gradient-to-tr from-blue-600 to-blue-400 text-white shadow-blue-500/40 shadow-lg absolute left-0 -mt-4 grid h-16 w-16 place-items-center"
          >
            <svg
              class="w-6 h-6 text-white stroke-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 32 32"
            >
              <path
                d="M31 20.349H1a.5.5 0 0 1-.5-.5v-3.947a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v1.211H5.96v-1.211a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v1.211h1.697v-1.211a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v1.211h1.632v-1.211a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v1.211h1.697v-1.211a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v1.211h1.697v-1.211a.5.5 0 0 1 .5-.5H31a.5.5 0 0 1 .5.5v3.947a.5.5 0 0 1-.5.5zm-29.5-1h29v-2.947h-1.763v1.211a.5.5 0 0 1-.5.5H25.54a.5.5 0 0 1-.5-.5v-1.211h-1.763v1.211a.5.5 0 0 1-.5.5H20.08a.5.5 0 0 1-.5-.5v-1.211h-1.763v1.211a.5.5 0 0 1-.5.5h-2.632a.5.5 0 0 1-.5-.5v-1.211h-1.763v1.211a.5.5 0 0 1-.5.5H9.224a.5.5 0 0 1-.5-.5v-1.211H6.96v1.211a.5.5 0 0 1-.5.5H3.763a.5.5 0 0 1-.5-.5v-1.211H1.5v2.947z"
              />
              <path
                d="M29.487 31.533H2.513a.5.5 0 0 1-.5-.5V19.849a.5.5 0 0 1 .5-.5h26.974a.5.5 0 0 1 .5.5v11.185a.5.5 0 0 1-.5.499zm-26.474-1h25.974V20.349H3.013v10.184zm6.194-12.421a.5.5 0 0 1-.5-.5v-7.396H4.313v7.396a.5.5 0 0 1-1 0V9.717a.5.5 0 0 1 .5-.5h5.395a.5.5 0 0 1 .5.5v7.896a.5.5 0 0 1-.501.499z"
              />
              <path
                d="M22.76 16.401a.5.5 0 0 1-.5-.5v-5.685H9.707v5.685a.5.5 0 0 1-1 0V9.717a.5.5 0 0 1 .5-.5H22.76a.5.5 0 0 1 .5.5v6.185a.5.5 0 0 1-.5.499z"
              />
              <path
                d="M22.76 12.257H9.207a.5.5 0 0 1 0-1H22.76a.5.5 0 0 1 0 1z"
              />
              <path
                d="M28.155 18.112a.5.5 0 0 1-.5-.5v-7.396H23.26v7.396a.5.5 0 0 1-1 0V9.717a.5.5 0 0 1 .5-.5h5.395a.5.5 0 0 1 .5.5v7.896a.5.5 0 0 1-.5.499zm-8.208 13.421h-7.895a.5.5 0 0 1-.5-.5v-4.605c0-2.452 1.995-4.447 4.447-4.447s4.447 1.995 4.447 4.447v4.605a.497.497 0 0 1-.499.5zm-7.394-1h6.895v-4.105c0-1.9-1.546-3.447-3.447-3.447s-3.447 1.547-3.447 3.447v4.105zm-1.931-20.316H2.398a.5.5 0 0 1-.5-.5V5.77a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v1.21h1.697V5.77a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v3.947a.499.499 0 0 1-.499.5zm-7.724-1h7.224V6.27H8.358v1.21a.5.5 0 0 1-.5.5H5.161a.5.5 0 0 1-.5-.5V6.27H2.898v2.947z"
              />
              <path
                d="M29.569 10.217h-8.224a.5.5 0 0 1-.5-.5V5.77a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v1.21h1.698V5.77a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v3.947a.5.5 0 0 1-.5.5zm-7.724-1h7.224V6.27h-1.763v1.21a.5.5 0 0 1-.5.5h-2.698a.5.5 0 0 1-.5-.5V6.27h-1.763v2.947zM15.967 7.98a.5.5 0 0 1-.5-.5V.967a.5.5 0 0 1 .5-.5h3.75a.501.501 0 0 1 .311.891l-3.562 2.837V7.48a.497.497 0 0 1-.499.5zm.5-6.513v1.449l1.82-1.449h-1.82z"
              />
              <path
                d="M18.138 10.217h-4.342a.5.5 0 0 1-.5-.5V7.645a.5.5 0 0 1 .5-.5h4.342a.5.5 0 0 1 .5.5v2.072a.5.5 0 0 1-.5.5zm-3.842-1h3.342V8.145h-3.342v1.072zM7.694 24.888H5.326a.5.5 0 0 1-.5-.5v-2.104a.5.5 0 0 1 .5-.5h2.368a.5.5 0 0 1 .5.5v2.104a.5.5 0 0 1-.5.5zm-1.868-1h1.368v-1.104H5.826v1.104zm20.816 1h-2.369a.5.5 0 0 1-.5-.5v-2.104a.5.5 0 0 1 .5-.5h2.369a.5.5 0 0 1 .5.5v2.104a.5.5 0 0 1-.5.5zm-1.869-1h1.369v-1.104h-1.369v1.104z"
              />
            </svg>
          </div>
        </div>

        <div
          class="relative flex flex-col bg-clip-border rounded-xl bg-white dark:bg-slate-700 dark:text-gray-200 text-gray-700 shadow-md"
        >
          <div class="p-4 text-right">
            <p
              class="block antialiased text-base leading-normal font-normal text-blue-gray-600"
            >
              الامداد الطبي
            </p>
            <h4
              class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900 dark:text-white"
            >
              {{ dashboard_data.total_of_medical_supplies }}
            </h4>
          </div>

          <div
            class="bg-clip-border mx-4 rounded-xl overflow-hidden bg-gradient-to-tr from-blue-600 to-blue-400 text-white shadow-blue-500/40 shadow-lg absolute left-0 -mt-4 grid h-16 w-16 place-items-center"
          >
            <svg
              class="w-6 h-6 text-white fill-current"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              viewBox="0 0 64 64"
            >
              <path
                d="M54.6 42.23a4.49 4.49 0 0 1-2 3 4.33 4.33 0 0 1-3.41.66 3.62 3.62 0 0 1-2.77-3.6 4.55 4.55 0 0 1 4.48-4.46 4.17 4.17 0 0 1 .91.1 3.66 3.66 0 0 1 2.79 4.3Z"
              />
              <path
                d="M30.68 22.83A5.28 5.28 0 1 0 36 28.11a5.29 5.29 0 0 0-5.32-5.28Zm.71 6v3.11H30v-3.12h-3.14V27.4H30v-3.12h1.42v3.12h3.08v1.42Zm-.71-6A5.28 5.28 0 1 0 36 28.11a5.29 5.29 0 0 0-5.32-5.28Zm.71 6v3.11H30v-3.12h-3.14V27.4H30v-3.12h1.42v3.12h3.08v1.42Zm26.73 1.47-4.59-5a3.48 3.48 0 0 0-2.64-1.17h-5.71l.51-4.7A1.33 1.33 0 0 0 44.34 18H14a1.56 1.56 0 0 0-1.56 1.37l-.06.59-.19 1.76v.1h-3a.91.91 0 1 0 0 1.83H12l-.17 1.59v.11H6.54a.91.91 0 0 0 0 1.83h5.08l-.17 1.59v.1H8.84a.91.91 0 0 0 0 1.83h2.4l-.17 1.59v.1H5.79a.91.91 0 0 0 0 1.83h5.07L10 41.93h6v-.23a6.06 6.06 0 0 1 4.63-5.14 5 5 0 0 1 6.48 4.25c0 .36 0 .73.06 1.11h17.77a1.36 1.36 0 0 0 0-.17 6.19 6.19 0 0 1 5.33-5.34A5 5 0 0 1 56 40.5c.08.46.08.93.13 1.44h.65a1.64 1.64 0 0 0 1.66-1.54c.21-2.38.41-4.76.62-7.14a3.69 3.69 0 0 0-.94-2.96Zm-27.44 4.61a6.8 6.8 0 1 1 6.8-6.8 6.81 6.81 0 0 1-6.8 6.8Zm15.26-4.12c.1-1.19-.17-3.64.4-4.66s2.61-.52 3.76-.53a2.82 2.82 0 0 1 2.74 1.22l3.59 4Zm-15.26-8A5.28 5.28 0 1 0 36 28.11a5.29 5.29 0 0 0-5.32-5.28Zm3.82 6h-3.11v3.11H30v-3.08h-3.14V27.4H30v-3.12h1.42v3.12h3.08Z"
              />
              <path
                d="M25.66 41.57v.32A4.61 4.61 0 0 1 21.53 46a3.66 3.66 0 0 1-3-1 3.82 3.82 0 0 1-1.09-3v-.24a4.5 4.5 0 0 1 2.22-3.25 4.43 4.43 0 0 1 2.22-.62 4 4 0 0 1 .76.07 3.88 3.88 0 0 1 .73.22 3.64 3.64 0 0 1 2.29 3.39Z"
              />
            </svg>
          </div>
        </div>

        <div
          class="relative flex flex-col bg-clip-border rounded-xl bg-white dark:bg-slate-700 dark:text-gray-200 text-gray-700 shadow-md"
        >
          <div class="p-4 text-right">
            <p
              class="block antialiased text-base leading-normal font-normal text-blue-gray-600"
            >
              المسجلين
            </p>
            <h4
              class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900 dark:text-white"
            >
              {{ dashboard_data.total_of_citizen }}
            </h4>
          </div>

          <div
            class="bg-clip-border mx-4 rounded-xl overflow-hidden bg-gradient-to-tr from-blue-600 to-blue-400 text-white shadow-blue-500/40 shadow-lg absolute left-0 -mt-4 grid h-16 w-16 place-items-center"
          >
            <svg
              class="w-6 h-6 text-white fill-current"
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 50 50"
              viewBox="0 0 50 50"
            >
              <path
                d="M24.3141,5.9217c-1.1045,0-2,0.8955-2,2v1.0835c0,3.0571-2.331,5.5801-5.3088,5.8854h-6.6319c-2.9783-0.3052-5.3093-2.8283-5.3093-5.8854V7.9217c0-2.6419-4-2.6449-4,0v1.0835c0,4.4979,3.0131,8.3001,7.1251,9.5096v11.2928c-0.0042,0.0524-0.0157,0.1027-0.0157,0.1561v16c0,1.1045,0.8955,2,2,2s2-0.8955,2-2V30.9219h2.9585v15.0419c0,1.1045,0.8955,2,2,2s2-0.8955,2-2V30.9219h0.0573v-12.407c4.1119-1.2095,7.1249-5.0116,7.1249-9.5096V7.9217C26.3141,6.8173,25.4186,5.9217,24.3141,5.9217z"
              />
              <path
                d="M13.6893 12.9219c2.2091 0 4-1.7909 4-4 0-2.2092-1.7909-4-4-4C8.4061 4.9219 8.3991 12.9219 13.6893 12.9219zM6.06 8.736v.27M4 17.366H2.26v-.5C1.8611 16.8992 1.3929 16.8715 1 16.736v4.72h6.19v-2.22C6.01 18.796 4.94 18.166 4 17.366zM47.52 17.366v-1.33h-1.18v-3.24H45.1v3.24h-1.17v-1.97h-2.51v1.97H40.3v-9.69h-.62v-2.81h-.96v-1.5h-2.7v1.5h-.96v2.81h-.61v11.02h-.92v-7.93H27.29c-.06 1.73-.54 3.39-1.37 4.85.22.16.36.43.36.75 0 .52-.4.94-.89.94-.18 0-.35-.05-.49-.15-1.22 1.51-2.83 2.71-4.71 3.41v2.22H49v-4.09H47.52zM28.2 15.976c-.51 0-.92-.42-.92-.94 0-.53.41-.94.92-.94.49 0 .89.41.89.94C29.09 15.556 28.69 15.976 28.2 15.976zM28.2 12.956c-.51 0-.92-.42-.92-.93 0-.54.41-.96.92-.96.49 0 .89.42.89.96C29.09 12.536 28.69 12.956 28.2 12.956zM30.98 15.976c-.5 0-.89-.42-.89-.94 0-.53.39-.94.89-.94s.92.41.92.94C31.9 15.556 31.48 15.976 30.98 15.976zM30.98 12.956c-.5 0-.89-.42-.89-.93 0-.54.39-.96.89-.96s.92.42.92.96C31.9 12.536 31.48 12.956 30.98 12.956zM36.34 16.576h-1.06v-8.12h1.06V16.576zM37.89 16.576h-1.03v-8.12h1.03V16.576zM39.46 16.576h-1.05v-8.12h1.05V16.576z"
              />
              <rect
                width="2.259"
                height="3.54"
                x="30.459"
                y="4.81"
              />
              <path d="M1.355,16.756" />
            </svg>
          </div>
        </div>

        <div
          class="relative flex flex-col bg-clip-border rounded-xl bg-white dark:bg-slate-700 dark:text-gray-200 text-gray-700 shadow-md"
        >
          <div class="p-4 text-right">
            <p
              class="block antialiased text-base leading-normal font-normal text-blue-gray-600"
            >
              اللقاحات
            </p>
            <h4
              class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900 dark:text-white"
            >
              {{ dashboard_data.total_of_vaccines }}
            </h4>
          </div>

          <div
            class="bg-clip-border mx-4 rounded-xl overflow-hidden bg-gradient-to-tr from-blue-600 to-blue-400 text-white shadow-blue-500/40 shadow-lg absolute left-0 -mt-4 grid h-16 w-16 place-items-center"
          >
            <svg
              class="mw-6 h-6 text-white stroke-current stroke-2"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 3"
              viewBox="0 0 64 64"
            >
              <path
                d="M51.707,1.293a1,1,0,0,0-1.414,0l-3,3a1,1,0,0,0,0,1.414L50.086,8.5,47,11.586,44.707,9.293a1,1,0,0,0-1.414,0l-29,29a1,1,0,0,0,0,1.414L16.086,41.5l-2.793,2.793a1,1,0,0,0,0,1.414L15.086,47.5,1.293,61.293l1.414,1.414L16.5,48.914l1.793,1.793a1,1,0,0,0,1.414,0L22.5,47.914l1.793,1.793a1,1,0,0,0,1.414,0L44.715,30.7A2.951,2.951,0,0,0,46,31v2H45a4,4,0,0,0-4,4V59a4,4,0,0,0,4,4H57a4,4,0,0,0,4-4V37a4,4,0,0,0-4-4H56V31a3,3,0,0,0,0-6V24a3,3,0,0,0-1.826-2.76l.533-.533a1,1,0,0,0,0-1.414L52.414,17,55.5,13.914l2.793,2.793a1,1,0,0,0,1.414,0l3-3a1,1,0,0,0,0-1.414ZM19,48.586,15.414,45,17.5,42.914,21.086,46.5Zm6-1L16.414,39l13-13H43.78A2.981,2.981,0,0,0,43,28a2.926,2.926,0,0,0,.081.666l-1.374-1.373-1.414,1.414L42.086,30.5,39,33.586l-3.293-3.293-1.414,1.414L37.586,35,34.5,38.086l-1.793-1.793-1.414,1.414L33.086,39.5,30,42.586l-3.293-3.293-1.414,1.414L28.586,44ZM59,55H48V40H59ZM55,35h2a2,2,0,0,1,2,2v1H47a1,1,0,0,0-1,1V56a1,1,0,0,0,1,1H59v2a2,2,0,0,1-2,2H45a2,2,0,0,1-2-2V37a2,2,0,0,1,2-2h2a1,1,0,0,0,1-1V31h6v3A1,1,0,0,0,55,35Zm2-7a1,1,0,0,1-1,1H46a1,1,0,0,1,0-2H56A1,1,0,0,1,57,28Zm-9-3V24a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v1Zm3.586-4H49a3,3,0,0,0-3,3H31.414L44,11.414,52.586,20ZM51,15.586,48.414,13,51.5,9.914,54.086,12.5Zm8-1L49.414,5,51,3.414,60.586,13Z"
              />
            </svg>
          </div>
        </div>

        <div
          class="relative flex flex-col bg-clip-border rounded-xl bg-white dark:bg-slate-700 dark:text-gray-200 text-gray-700 shadow-md"
        >
          <div class="p-4 text-right">
            <p
              class="block antialiased text-base leading-normal font-normal text-blue-gray-600"
            >
              المستخدمين
            </p>
            <h4
              class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900 dark:text-white"
            >
              {{ dashboard_data.total_of_user }}
            </h4>
          </div>

          <div
            class="bg-clip-border mx-4 rounded-xl overflow-hidden bg-gradient-to-tr from-blue-600 to-blue-400 text-white shadow-blue-500/40 shadow-lg absolute left-0 -mt-4 grid h-16 w-16 place-items-center"
          >
            <svg
              class="w-6 h-6 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
          </div>
        </div>

        <div
          class="relative flex flex-col bg-clip-border rounded-xl bg-white dark:bg-slate-700 dark:text-gray-200 text-gray-700 shadow-md"
        >
          <div class="p-4 text-right">
            <p
              class="block antialiased text-base leading-normal font-normal text-blue-gray-600"
            >
              محصلة اليوم
            </p>
            <h4
              class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900 dark:text-white"
            >
              {{ dashboard_data.total_of_Obtained_Vaccinese_in_this_day }}
            </h4>
          </div>

          <div
            class="bg-clip-border mx-4 rounded-xl overflow-hidden bg-gradient-to-tr from-blue-600 to-blue-400 text-white shadow-blue-500/40 shadow-lg absolute left-0 -mt-4 grid h-16 w-16 place-items-center"
          >
            <svg
              class="w-6 h-6 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
          </div>
        </div>

        <div
          class="relative flex flex-col bg-clip-border rounded-xl bg-white dark:bg-slate-700 dark:text-gray-200 text-gray-700 shadow-md"
        >
          <div class="p-4 text-right">
            <p
              class="block antialiased text-base leading-normal font-normal text-blue-gray-600"
            >
              محصلة الشهر
            </p>
            <h4
              class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900 dark:text-white"
            >
              {{ dashboard_data.total_of_Obtained_Vaccinese_in_this_month }}
            </h4>
          </div>

          <div
            class="bg-clip-border mx-4 rounded-xl overflow-hidden bg-gradient-to-tr from-blue-600 to-blue-400 text-white shadow-blue-500/40 shadow-lg absolute left-0 -mt-4 grid h-16 w-16 place-items-center"
          >
            <svg
              class="w-6 h-6 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
          </div>
        </div>

        <div
          class="relative flex flex-col bg-clip-border rounded-xl bg-white dark:bg-slate-700 dark:text-gray-200 text-gray-700 shadow-md"
        >
          <div class="p-4 text-right">
            <p
              class="block antialiased text-base leading-normal font-normal text-blue-gray-600"
            >
              محصلة السنة
            </p>
            <h4
              class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900 dark:text-white"
            >
              {{ dashboard_data.total_of_Obtained_Vaccinese_this_in_year }}
            </h4>
          </div>

          <div
            class="bg-clip-border mx-4 rounded-xl overflow-hidden bg-gradient-to-tr from-blue-600 to-blue-400 text-white shadow-blue-500/40 shadow-lg absolute left-0 -mt-4 grid h-16 w-16 place-items-center"
          >
            <svg
              class="w-6 h-6 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="mt-12">
        <p class="text-lg font-semibold text-slate-900 dark:text-white">
          أكثر البلديات سحب
        </p>

        <div class="mt-6">
          <div class="mt-2 flex justify-between items-center">
            <button
              :class="
                filter_period_most_consumed_muncipals == 2
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
              @click="period_fun_most_consumed_muncipals(2)"
            >
              هذا اليوم
            </button>

            <button
              :class="
                filter_period_most_consumed_muncipals == 3
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
              @click="period_fun_most_consumed_muncipals(3)"
            >
              هذا الشهر
            </button>

            <button
              :class="
                filter_period_most_consumed_muncipals == 4
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
              @click="period_fun_most_consumed_muncipals(4)"
            >
              هذه السنة
            </button>

            <button
              :class="
                filter_period_most_consumed_muncipals == 1
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
              @click="period_fun_most_consumed_muncipals(1)"
            >
              الكل
            </button>

            <!-- <button
              @click="period_fun_most_consumed_muncipals(5)"
              :class="
                filter_period_most_consumed_muncipals == 5
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              مخصص
            </button> -->
          </div>
        </div>

        <div class="h-98">
          <BarChart
            v-if="
              most_consumed_muncipals_labels.length > 0 &&
                most_consumed_muncipals_datasets[0].data.length > 0
            "
            :labels="most_consumed_muncipals_labels"
            :datasets="most_consumed_muncipals_datasets"
          />

          <div
            v-else
            class=""
          >
            <div
              class="animate-pulse flex justify-center pt-4 items-end w-full h-full"
            >
              <div class="mx-2 w-20 bg-red-400 rounded h-96" />
              <div class="mx-2 w-20 bg-red-400 rounded h-48" />
              <div class="mx-2 w-20 bg-red-400 rounded h-56" />
              <div class="mx-2 w-20 bg-red-400 rounded h-48" />
              <div class="mx-2 w-20 bg-red-400 rounded h-96" />
              <div class="mx-2 w-20 bg-red-400 rounded h-56" />
              <div class="mx-2 w-20 bg-red-400 rounded h-40" />
              <div class="mx-2 w-20 bg-red-400 rounded h-96" />
              <div class="mx-2 w-20 bg-red-400 rounded h-48" />
              <div class="mx-2 w-20 bg-red-400 rounded h-12" />
              <div class="mx-2 w-20 bg-red-400 rounded h-40" />
              <div class="mx-2 w-20 bg-red-400 rounded h-72" />
            </div>
          </div>
        </div>
      </div>

      <div class="mt-12">
        <p class="text-lg font-semibold text-slate-900 dark:text-white">
          أكثر مراكز التطعيم سحب
        </p>

        <div class="mt-6">
          <div class="mt-2 flex justify-between items-center">
            <button
              :class="
                filter_period_most_consumed_helth_center == 2
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
              @click="period_fun_most_consumed_helth_center(2)"
            >
              هذا اليوم
            </button>

            <button
              :class="
                filter_period_most_consumed_helth_center == 3
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
              @click="period_fun_most_consumed_helth_center(3)"
            >
              هذا الشهر
            </button>

            <button
              :class="
                filter_period_most_consumed_helth_center == 4
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
              @click="period_fun_most_consumed_helth_center(4)"
            >
              هذه السنة
            </button>

            <button
              :class="
                filter_period_most_consumed_helth_center == 1
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
              @click="period_fun_most_consumed_helth_center(1)"
            >
              الكل
            </button>

            <!-- <button
              @click="period_fun_most_consumed_helth_center(5)"
              :class="
                filter_period_most_consumed_helth_center == 5
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              مخصص
            </button> -->
          </div>
        </div>

        <div class="h-98">
          <BarChart
            v-if="
              most_consumeds_helth_center_labels.length > 0 &&
                most_consumeds_helth_center_datasets[0].data.length > 0
            "
            :labels="most_consumeds_helth_center_labels"
            :datasets="most_consumeds_helth_center_datasets"
          />

          <div
            v-else
            class=""
          >
            <div
              class="animate-pulse flex justify-center pt-4 items-end w-full h-full"
            >
              <div class="mx-2 w-20 bg-blue-400 rounded h-96" />
              <div class="mx-2 w-20 bg-blue-400 rounded h-48" />
              <div class="mx-2 w-20 bg-blue-400 rounded h-56" />
              <div class="mx-2 w-20 bg-blue-400 rounded h-48" />
              <div class="mx-2 w-20 bg-blue-400 rounded h-96" />
              <div class="mx-2 w-20 bg-blue-400 rounded h-56" />
              <div class="mx-2 w-20 bg-blue-400 rounded h-40" />
              <div class="mx-2 w-20 bg-blue-400 rounded h-96" />
              <div class="mx-2 w-20 bg-blue-400 rounded h-48" />
              <div class="mx-2 w-20 bg-blue-400 rounded h-12" />
              <div class="mx-2 w-20 bg-blue-400 rounded h-40" />
              <div class="mx-2 w-20 bg-blue-400 rounded h-72" />
            </div>
          </div>
        </div>
      </div>

      <div class="mt-12">
        <p class="text-lg font-semibold text-slate-900 dark:text-white">
          أكثر اللقاحات سحب
        </p>

        <div class="mt-6">
          <div class="mt-2 flex justify-between items-center">
            <button
              :class="
                filter_period_most_consumed_vaccine == 2
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
              @click="period_fun_most_consumed_vaccine(2)"
            >
              هذا اليوم
            </button>

            <button
              :class="
                filter_period_most_consumed_vaccine == 3
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
              @click="period_fun_most_consumed_vaccine(3)"
            >
              هذا الشهر
            </button>

            <button
              :class="
                filter_period_most_consumed_vaccine == 4
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
              @click="period_fun_most_consumed_vaccine(4)"
            >
              هذه السنة
            </button>

            <button
              :class="
                filter_period_most_consumed_vaccine == 1
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
              @click="period_fun_most_consumed_vaccine(1)"
            >
              الكل
            </button>

            <!-- <button
              @click="period_fun_most_consumed_vaccine(5)"
              :class="
                filter_period_most_consumed_vaccine == 5
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              مخصص
            </button> -->
          </div>
        </div>
        <div class="h-98">
          <BarChart
            v-if="
              most_consumeds_Vaccine_labels.length > 0 &&
                most_consumeds_Vaccine_datasets[0].data.length > 0
            "
            :labels="most_consumeds_Vaccine_labels"
            :datasets="most_consumeds_Vaccine_datasets"
          />

          <div
            v-else
            class=""
          >
            <div
              class="animate-pulse flex justify-center pt-4 items-end w-full h-full"
            >
              <div class="mx-2 w-20 bg-green-400 rounded h-96" />
              <div class="mx-2 w-20 bg-green-400 rounded h-48" />
              <div class="mx-2 w-20 bg-green-400 rounded h-56" />
              <div class="mx-2 w-20 bg-green-400 rounded h-48" />
              <div class="mx-2 w-20 bg-green-400 rounded h-96" />
              <div class="mx-2 w-20 bg-green-400 rounded h-56" />
              <div class="mx-2 w-20 bg-green-400 rounded h-40" />
              <div class="mx-2 w-20 bg-green-400 rounded h-96" />
              <div class="mx-2 w-20 bg-green-400 rounded h-48" />
              <div class="mx-2 w-20 bg-green-400 rounded h-12" />
              <div class="mx-2 w-20 bg-green-400 rounded h-40" />
              <div class="mx-2 w-20 bg-green-400 rounded h-72" />
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-4 mt-12">
        <div class="col-span-2">
          <p class="text-lg font-semibold text-slate-900 dark:text-white">
            المراكز الصحية على الخريطة
          </p>
          <GmapMap
            class="mt-4"
            :center="{ lat: 27, lng: 17 }"
            :zoom="5.2"
            map-type-id="terrain"
            style="height: 450px"
          >
            <GmapMarker
              v-for="(m, index) in markers_location_of_health_center"
              :key="index"
              class="relative"
              :position="m.position"
              :clickable="true"
              :draggable="false"
              @click="openInfoWindow(m, 1)"
            >
              <div class="bg-red-600 w-24 h-24">
                {{ openedMarkerID }}sssssssssss
              </div>
            </GmapMarker>

            <gmap-info-window
              v-if="selected_location_health_center !== null"
              :position="{
                lat: selected_location_health_center.position.lat,
                lng: selected_location_health_center.position.lng,
              }"
              :opened="info_box_open_health_center"
              @closeclick="closeInfoWindow(1)"
            >
              <div
                class="infoWindow text-lg font-bold text-black text-center px-2 mt-4 w-full"
              >
                <h2 id="infoWindow-location">
                  {{ selected_location_health_center.name }}
                </h2>
              </div>
            </gmap-info-window>

            <!-- 
                    :icon="require('@/assets/images/place-icon.svg').default"
                 -->
          </GmapMap>
        </div>

        <div class="mt-10">
          <p class="text-lg font-semibold text-slate-900 dark:text-white">
            البلديات على الخريطة
          </p>
          <GmapMap
            class="mt-4"
            :center="{ lat: 27, lng: 17 }"
            :zoom="5.2"
            map-type-id="terrain"
            style="height: 450px"
          >
            <GmapMarker
              v-for="(m, index) in markers_location_of_muncipal"
              :key="index"
              class="relative"
              :position="m.position"
              :clickable="true"
              :draggable="false"
              @click="openInfoWindow(m, 2)"
            >
              <div class="bg-red-600 w-24 h-24">
                {{ openedMarkerID }}
              </div>
            </GmapMarker>

            <gmap-info-window
              v-if="selected_location_muncipal !== null"
              :position="{
                lat: selected_location_muncipal.position.lat,
                lng: selected_location_muncipal.position.lng,
              }"
              :opened="info_box_open_muncipal"
              @closeclick="closeInfoWindow(2)"
            >
              <div
                class="infoWindow text-lg font-bold text-black text-center px-2 mt-4 w-full"
              >
                <h2 id="infoWindow-location">
                  {{ selected_location_muncipal.name }}
                </h2>
              </div>
            </gmap-info-window>
          </GmapMap>
        </div>

        <div class="mt-10">
          <p class="text-lg font-semibold text-slate-900 dark:text-white">
            الامداد الطبي على الخريطة
          </p>
          <GmapMap
            class="mt-4"
            :center="{ lat: 27, lng: 17 }"
            :zoom="5.2"
            map-type-id="terrain"
            style="height: 450px"
          >
            <GmapMarker
              v-for="(m, index) in markers_location_medical_supplies"
              :key="index"
              class="relative"
              :position="m.position"
              :clickable="true"
              :draggable="false"
              @click="openInfoWindow(m, 3)"
            >
              <div class="bg-red-600 w-24 h-24">
                {{ openedMarkerID }}
              </div>
            </GmapMarker>

            <gmap-info-window
              v-if="selected_location_medical_supplies !== null"
              :position="{
                lat: selected_location_medical_supplies.position.lat,
                lng: selected_location_medical_supplies.position.lng,
              }"
              :opened="info_box_open_medical_supplies"
              @closeclick="closeInfoWindow(3)"
            >
              <div
                class="infoWindow text-lg font-bold text-black text-center px-2 mt-4 w-full"
              >
                <h2 id="infoWindow-location">
                  {{ selected_location_medical_supplies.name }}
                </h2>
              </div>
            </gmap-info-window>
          </GmapMap>
        </div>
      </div>

      <!-- <div class="my-20">
        <GmapMap
            class="mt-4"
            :center="{ lat: 26.745371, lng:  17.732620 }"
            :zoom="6"
            map-type-id="terrain"
            style="height: 850px"
          >
            <GmapMarker
              class="relative"
              :key="index"
              v-for="(m, index) in markers_location_of_muncipal"
              :position="m.position"
              :clickable="true"
              :draggable="false"
              @click="openInfoWindow(m, 2)"
            >
              <div class="bg-red-600 w-24 h-24">
                {{ openedMarkerID }}
              </div>
            </GmapMarker>

            <gmap-info-window
              v-if="selected_location_muncipal !== null"
              :position="{
                lat: selected_location_muncipal.position.lat,
                lng: selected_location_muncipal.position.lng,
              }"
              :opened="info_box_open_muncipal"
              @closeclick="closeInfoWindow(2)"
            >
              <div
                class="infoWindow text-lg font-bold text-black text-center px-2 mt-4 w-full"
              >
                <h2 id="infoWindow-location">
                  {{ selected_location_muncipal.name }}
                </h2>
              </div>
            </gmap-info-window>
          </GmapMap>
      </div> -->
    </div>
  </div>
</template>

<script>
import Dashboard from "@/services/DashboardService";

import BarChart from "@/components/ChartJS/Bar.vue";

export default {
  components: {
    BarChart,
  },

  data() {
    return {
      openedMarkerID: null,
      center: { lat: 51.093048, lng: 6.84212 },
      markers_location_of_health_center: [],
      markers_location_of_muncipal: [],
      markers_location_medical_supplies: [],

      selected_location_health_center: null,
      selected_location_muncipal: null,
      selected_location_medical_supplies: null,

      info_box_open_health_center: false,
      info_box_open_muncipal: false,
      info_box_open_medical_supplies: false,

      dashboard_data: {},
      dashboard_locations_data: {},
      dashboard_consumed_muncipals_data: {},
      dashboard_consumed_helth_center_data: {},
      dashboard_consumed_vaccine_data: {},

      most_consumed_muncipals_labels: [],

      most_consumed_muncipals_datasets: [
        {
          color: "#FFF",
          label: " ",
          backgroundColor: "#f87979",
          data: [],
        },
      ],

      filter_most_consumed_muncipals_date_from: "",
      filter_most_consumed_muncipals_date_to: "",

      filter_period_most_consumed_muncipals: 2,

      most_consumeds_helth_center_labels: [],

      most_consumeds_helth_center_datasets: [
        {
          color: "#FFF",
          label: " ",
          backgroundColor: "#3574ef",
          data: [],
        },
      ],

      filter_most_consumed_helth_center_date_from: "",
      filter_most_consumed_helth_center_date_to: "",

      filter_period_most_consumed_helth_center: 2,

      most_consumeds_Vaccine_labels: [],

      most_consumeds_Vaccine_datasets: [
        {
          color: "#FFF",
          label: " ",
          backgroundColor: "#49cc90",
          data: [],
        },
      ],

      filter_most_consumed_vaccine_date_from: "",
      filter_most_consumed_vaccine_date_to: "",
      filter_period_most_consumed_vaccine: 2,

      data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20],
    };
  },

  created() {
    this.getDashboardStatisticsNumber();

    var date = new Date();

    var month = date.getMonth() + 1;
    var day = date.getDate();

    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;

    this.filter_most_consumed_muncipals_date_from =
      date.getFullYear() + "-" + month + "-" + day;
    this.filter_most_consumed_muncipals_date_to =
      date.getFullYear() + "-" + month + "-" + day;

    this.filter_most_consumed_helth_center_date_from =
      date.getFullYear() + "-" + month + "-" + day;
    this.filter_most_consumed_helth_center_date_to =
      date.getFullYear() + "-" + month + "-" + day;

    this.filter_most_consumed_vaccine_date_from =
      date.getFullYear() + "-" + month + "-" + day;
    this.filter_most_consumed_vaccine_date_to =
      date.getFullYear() + "-" + month + "-" + day;
  },
  methods: {
    period_fun_most_consumed_muncipals(p) {
      this.filter_period_most_consumed_muncipals = p;
      this.getDashboardMostConsumedMuncipal();
    },

    period_fun_most_consumed_helth_center(p) {
      this.filter_period_most_consumed_helth_center = p;
      this.getDashboardMostConsumedHealthCenter();
    },

    period_fun_most_consumed_vaccine(p) {
      this.filter_period_most_consumed_vaccine = p;
      this.getDashboardMostConsumedVaccine();
    },

    openInfoWindow(location, plase) {
      switch (plase) {
        case 1:
          this.selected_location_health_center = location;
          this.info_box_open_health_center = true;
          break;

        case 2:
          this.selected_location_muncipal = location;
          this.info_box_open_muncipal = true;
          break;

        case 3:
          this.selected_location_medical_supplies = location;
          this.info_box_open_medical_supplies = true;
          break;

        // default:
        //     break;
      }
    },

    closeInfoWindow(plase) {
      switch (plase) {
        case 1:
          this.info_box_open_health_center = false;
          break;

        case 2:
          this.info_box_open_muncipal = false;
          break;

        case 3:
          this.info_box_open_medical_supplies = false;
          break;

        // default:
        //     break;
      }
    },

    getDashboardStatisticsNumber() {
      let loader = this.$loading.show({
        loader: this.loader,
      });

      console.log("this.dashboard_data.most_consumed_muncipals.length");

      Dashboard.getDashboardStatisticsNumberForAdministrationOfVaccinations()
        .then((res) => {
          setTimeout(() => {
            loader.hide();

            this.dashboard_data = res.data;

            this.getDashboardLocations();
            this.getDashboardMostConsumedMuncipal();
            this.getDashboardMostConsumedHealthCenter();
            this.getDashboardMostConsumedVaccine();
          }, 10);
        })
        .catch((err) => {
          loader.hide();

          this.$swal.fire({
            icon: "error",
            title: "...عذرا",
            text: err.response.data.message,
          });
        });
    },

    getDashboardLocations() {
      Dashboard.getDashboardLocationsForAdministrationOfVaccinations()
        .then((res) => {
          setTimeout(() => {
            this.dashboard_locations_data = res.data;

            this.markers_location_of_health_center =
              this.dashboard_locations_data.location_of_health_center;
            this.markers_location_of_muncipal =
              this.dashboard_locations_data.location_of_muncipal;
            this.markers_location_medical_supplies =
              this.dashboard_locations_data.location_medical_supplies;

            //   for (let index = 0; index < this.dashboard_data.most_consumed_muncipals.length; index++) {
            //     const element = this.dashboard_data.most_consumed_muncipals[index];

            //     this.most_consumed_muncipals_labels.push(element.name)
            //     this.most_consumed_muncipals_datasets[0].data.push(element.total_obtained_Vaccines)
            //   }

            //   for (let index = 0; index < this.dashboard_data.most_consumeds_helth_center.length; index++) {
            //     const element = this.dashboard_data.most_consumeds_helth_center[index];

            //     this.most_consumeds_helth_center_labels.push(element.name)
            //     this.most_consumeds_helth_center_datasets[0].data.push(element.total_obtained_Vaccines)
            //   }

            //   for (let index = 0; index < this.dashboard_data.most_consumeds_Vaccine.length; index++) {
            //     const element = this.dashboard_data.most_consumeds_Vaccine[index];

            //     this.most_consumeds_Vaccine_labels.push(element.name_en)
            //     this.most_consumeds_Vaccine_datasets[0].data.push(element.total_obtained_Vaccines)
            //   }

            // this.total = this.dashboard_data.total;
          }, 10);
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: "...عذرا",
            text: err.response.data.message,
          });
        });
    },

    getDashboardMostConsumedMuncipal() {
      this.most_consumed_muncipals_labels = 0;
      this.most_consumed_muncipals_datasets[0].data = 0;

      Dashboard.getDashboardMostConsumedMuncipalForAdministrationOfVaccinations(
        this.filter_period_most_consumed_muncipals,
        this.filter_most_consumed_muncipals_date_from,
        this.filter_most_consumed_muncipals_date_to,
        false
      )
        .then((res) => {
          // setTimeout(() => {

          const labels = [];
          const datasets = [];

          this.dashboard_consumed_muncipals_data = res.data.list;

          for (
            let index = 0;
            index <
            this.dashboard_consumed_muncipals_data.most_consumed_muncipals
              .length;
            index++
          ) {
            const element =
              this.dashboard_consumed_muncipals_data.most_consumed_muncipals[
                index
              ];

            labels.push(element.name);
            datasets.push(element.total_obtained_Vaccines);
          }

          this.most_consumed_muncipals_labels = labels;
          this.most_consumed_muncipals_datasets[0].data = datasets;
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: "...عذرا",
            text: err.response.data.message,
          });
        });
    },

    getDashboardMostConsumedHealthCenter() {
      this.most_consumeds_helth_center_labels = 0;
      this.most_consumeds_helth_center_datasets[0].data = 0;

      Dashboard.getDashboardMostConsumedHealthCenterForAdministrationOfVaccinations(
        this.filter_period_most_consumed_helth_center,
        this.filter_most_consumed_helth_center_date_from,
        this.filter_most_consumed_helth_center_date_to,
        false
      )
        .then((res) => {
          const labels = [];
          const datasets = [];

          this.dashboard_consumed_helth_center_data = res.data;

          for (
            let index = 0;
            index <
            this.dashboard_consumed_helth_center_data
              .most_consumeds_helth_center_With_municipals.length;
            index++
          ) {
            const element =
              this.dashboard_consumed_helth_center_data
                .most_consumeds_helth_center_With_municipals[index];
            labels.push(element.name + " " + element.municipal);
            datasets.push(element.total_obtained_Vaccines);
          }

          this.most_consumeds_helth_center_labels = labels;
          this.most_consumeds_helth_center_datasets[0].data = datasets;
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: "...عذرا",
            text: err.response.data.message,
          });
        });
    },

    getDashboardMostConsumedVaccine() {
      this.most_consumeds_Vaccine_labels = 0;
      this.most_consumeds_Vaccine_datasets[0].data = 0;

      Dashboard.getDashboardMostConsumedVaccineForAdministrationOfVaccinations(
        this.filter_period_most_consumed_vaccine,
        this.filter_most_consumed_vaccine_date_from,
        this.filter_most_consumed_vaccine_date_to,
        false
      )
        .then((res) => {
          this.dashboard_consumed_vaccine_data = res.data.list;
          const labels = [];
          const datasets = [];

          for (
            let index = 0;
            index <
            this.dashboard_consumed_vaccine_data.most_consumeds_Vaccine.length;
            index++
          ) {
            const element =
              this.dashboard_consumed_vaccine_data.most_consumeds_Vaccine[
                index
              ];
            labels.push(element.name_en);
            datasets.push(element.total_obtained_Vaccines);
          }

          this.most_consumeds_Vaccine_labels = labels;
          this.most_consumeds_Vaccine_datasets[0].data = datasets;
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: "...عذرا",
            text: err.response.data.message,
          });
        });
    },
  },
};
</script>

<style></style>
